export const TIPOS_IDENTIFICACIONES = [
  { value: "DPI", text: "Doc. Personal de Identificación" },
  { value: "PAS", text: "Pasaporte" },
];

export const TIPOS_DEPENDIENTES = [
  { value: "C", text: "Esposo(a)" },
  { value: "H", text: "Hijo(a)" },
];

export const TIPOS_RELACION = [
  { value: "ESPOSA(O)", text: "Conyuge" },
  { value: "HIJA(O)", text: "Hijo" },
  { value: "HERMANA(O)", text: "Hermano" },
  { value: "MADRE", text: "Madre" },
  { value: "PADRE", text: "Padre" },
  { value: "OTROS", text: "Otros" },
];

export const TIPOS_SEXO = [
  { value: "F", text: "Femenino" },
  { value: "M", text: "Masculino" },
];

export const TIPOS_PLAN = [
  { value: "G", text: "Gastos Médicos" },
  { value: "D", text: "Dental" },
  { value: "GD", text: "G. Méd./Dental" },
];

export const TIPOS_PLAN_GENERAL = [
  { value: "V", text: "Vida" },
  { value: "G", text: "Gastos Médicos" },
  { value: "D", text: "Dental" },
  { value: "A", text: "Accidentes Personales" },
];

export const TIPOS_ESTADOCIVIL = [
  {
    value: "SOLTERO",
    text: "Soltera/o",
  },
  {
    value: "CASADO",
    text: "Casada/o",
  },
  {
    value: "VIUDO",
    text: "Viuda/o",
  },
];

export const TIPOS_BENEFICIARIOS = [
  { value: "P", text: "Principal" },
  { value: "C", text: "Secundario" },
];

export const TIPOS_CUENTASBANCARIAS = [
  { value: "CORRIENTE", text: "Corriente" },
  { value: "AHORRO", text: "Ahorro" },
];
